export default __webpack_public_path__ + "static/media/cloth_2.a78f105e.jpg";